import React, {useState, useContext} from "react";
import { useDispatch } from "react-redux";

///Styles
import { FaTimesCircle, FaCheckCircle, FaHourglassHalf, FaTrashAlt, FaSortUp,FaSortDown } from 'react-icons/fa';
import { BiEditAlt } from 'react-icons/bi'
import { Container } from "./styles";

///Components
import { formatMoney } from "../../../../../Utils/formatMoney";

///Services
import { MetasContext } from "../goalsContext";

export function Grid({ goals,handleIsOrder }) {
    const dispatch = useDispatch()
    const { setSearch, setIdBusiness, setDateGoal, setValueGoal, setValueBalancePoint, setIdMeta, setGoals,deleteGoal } = useContext(MetasContext);

    const [selected,setSelected] = useState('');
    const [isDesc,setIsDesc] = useState(false);

    function handleEdit(data) {
        setSearch(data.business);
        setIdMeta(data.idMeta);
        setIdBusiness(data.idBusiness);
        setDateGoal(data.dtMeta);
        setValueGoal(data.vlMeta);
        setValueBalancePoint(data.vlPontoEquilibrio);
        dispatch({ type: 'OPEN_MODALFORMS_CREATE', title: 'Editando Meta' })
    }

    function handleDelete(data) {
        //console.log(data)
        deleteGoal(data.idMeta, data.idBusiness);
        
        let newArr = goals.filter((item) => {
            return item.idMeta !== data.idMeta
        });

        setGoals(newArr)
    }

    function handleSortTable(data){
        handleIsOrder(data);
        setSelected(data);
        setIsDesc(!isDesc);
    }



    return (
        <Container>
            <thead>
                <tr>
                    <th onClick={() => handleSortTable('business')}>Empresa {selected === 'business' ? (isDesc ? <FaSortUp/> : <FaSortDown/> ): ''}</th>
                    <th onClick={() => handleSortTable('dtMeta')}>Mês/Ano {selected === 'dtMeta' ? (isDesc ? <FaSortUp/> : <FaSortDown/> ): ''}</th>
                    <th onClick={() => handleSortTable('receita')}>Receita {selected === 'receita' ? (isDesc ? <FaSortUp/> : <FaSortDown/> ): ''}</th>
                    <th onClick={() => handleSortTable('vlMeta')}>Valor Meta {selected === 'vlMeta' ? (isDesc ? <FaSortUp/> : <FaSortDown/> ): ''}</th>
                    <th>Status Meta</th>
                    <th onClick={() => handleSortTable('vlPontoEquilibrio')}>Ponto Equilíbrio {selected === 'vlPontoEquilibrio' ? (isDesc ? <FaSortUp/> : <FaSortDown/> ): ''} </th>
                    <th>Atingiu</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                {
                    goals.map((data) => {
                        return (
                            <tr key={data.idMeta}>
                                <td>{data.business}</td>
                                <td>{data.dtMeta}</td>
                                <td>{formatMoney(data.receita)}</td>
                                <td>{formatMoney(data.vlMeta)}</td>
                                <td>
                                    {
                                        data.wait === 1 ?
                                            <FaHourglassHalf />
                                            :
                                            data.statusMeta === 1 ?
                                                <FaCheckCircle color="#2e9699" />
                                                :
                                                <FaTimesCircle color="#e05f59" />
                                    }
                                </td>
                                <td>{formatMoney(data.vlPontoEquilibrio)}</td>
                                <td className={data.wait === 1 ? '' : `T${data.statusPtEquilibrio}`}>
                                    {
                                        data.wait === 1 ?
                                            'Aguardando'
                                            :
                                            data.statusPtEquilibrio === 1 ?
                                                'Lucro'
                                                :
                                                data.statusPtEquilibrio === 0 ?
                                                    'Ponto Equilíbrio'
                                                    :
                                                    'Prejuízo'
                                    }
                                </td>
                                <td className="edit">
                                    <BiEditAlt onClick={() => handleEdit(data)} />
                                    <FaTrashAlt onClick={() => handleDelete(data)} />
                                </td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </Container>
    )
}